<template>
  <div>
    <vue-headful
    :title="propsdata[0]['translation']['websites-title']"
    :description="propsdata[0]['translation']['websites-description']"
/>

<div v-if="loading" class="loader" style="margin: 100px auto;">
  <br><br>
  <div>
    <ul>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
    </ul>
  </div><span>{{propsdata[0]['translation']['websites-loading']}}</span>
</div>


    <div v-if="!loading" class="sc-kEYyzF grKTOC">
      <section class="section section-lg pt-0">
         <div class="container" style="padding-top: 7rem;">
            <div v-if="websites && websites.length" class="row">
                 <div class="col-12">
                    <h2 class="h1 mb-3">{{propsdata[0]['translation']['websites-websites']}}</h2>
                    <p>{{propsdata[0]['translation']['websites-copy-paste']}}</p>
                    <router-link to="/dashboard/add-website" class="sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ btnaddweb" style="color: rgb(255, 255, 255);"><svg width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-jhaWeW kclIni"><path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path></svg>{{propsdata[0]['translation']['websites-add']}}</router-link>
                 </div>
               <div v-for="(website, index) in websites" class="col-12 mb-4">
                  <div class="card bg-white border-light shadow-soft">
                     <div class="card-body p-4 p-lg-5">
                        <div class="row">
                           <div class="col-12 col-md-6 mb-4 mb-lg-0">
                              <h3 class="mb-3">{{website.website}}</h3>
                              <p class="text-gray mb-4">{{propsdata[0]['translation']['websites-created']}} {{website.fecha}}</p>
                              <div class="d-flex">
                                <a @click="el_sure(index)" style="color:#ffffff;" class="btn btn-secondary mr-3 animate-up-2 m-0"><i class="fas fa-times mr-2"></i>{{propsdata[0]['translation']['websites-delete']}}</a>
                                <router-link :to="'/dashboard/edit-website/'+website.scriptid" style="color:#ffffff;" class="btn btn-primary animate-up-2 m-0"><i class="fas fa-pen mr-2"></i>{{propsdata[0]['translation']['websites-edit']}}</router-link>
                              </div>
                              <p v-if="sure && numerosure === index" style="margin-top: 15px;">{{propsdata[0]['translation']['websites-sure']}} <a @click="delete_draft(index)" style="color:#5dba00;">{{propsdata[0]['translation']['websites-yes']}}</a> / <a @click="el_sure()" style="color:#ee5150;">NO</a></p>
                              <br>
                              <h4>{{propsdata[0]['translation']['websites-preview']}}</h4>
                              <p>{{propsdata[0]['translation']['websites-banner']}}</p>
                              <div class="upgrade__footer" style="bottom:0;width:100%;margin-left:auto;margin-right:auto;padding-top:25px;padding-bottom:25px;text-align:center;background:#f2f5f9;">
                                <a v-if="website.privacypolicyid" class="upgrade__footer-link" style="display:inline-block;padding:8px 16px;vertical-align:top;color:#98a1b3;-webkit-transition:color .2s;transition:color .2s" :href="'https://termify.io/privacy-policy/'+website.privacypolicyid" target="_blank">{{propsdata[0]['translation']['websites-privacy']}}</a>
                                <a v-if="website.termsid" class="upgrade__footer-link" style="display:inline-block;padding:8px 16px;vertical-align:top;color:#98a1b3;-webkit-transition:color .2s;transition:color .2s" :href="'https://termify.io/terms-and-conditions/'+website.termsid" target="_blank">{{propsdata[0]['translation']['websites-terms']}}</a>
                                <a v-if="website.disclaimerid" class="upgrade__footer-link" style="display:inline-block;padding:8px 16px;vertical-align:top;color:#98a1b3;-webkit-transition:color .2s;transition:color .2s" :href="'https://termify.io/disclaimer/'+website.disclaimerid" target="_blank">{{propsdata[0]['translation']['websites-disclaimers']}}</a>
                                <a v-if="website.cookiepolicyid" class="upgrade__footer-link" style="display:inline-block;padding:8px 16px;vertical-align:top;color:#98a1b3;-webkit-transition:color .2s;transition:color .2s" :href="'https://termify.io/cookie-policy/'+website.cookiepolicyid" target="_blank">{{propsdata[0]['translation']['websites-cookie']}}</a>
                                <a v-if="website.eulaid" class="upgrade__footer-link" style="display:inline-block;padding:8px 16px;vertical-align:top;color:#98a1b3;-webkit-transition:color .2s;transition:color .2s" :href="'https://termify.io/eula/'+website.eulaid" target="_blank">{{propsdata[0]['translation']['websites-eula']}}</a>
                                <a v-if="website.returnandrefundid" class="upgrade__footer-link" style="display:inline-block;padding:8px 16px;vertical-align:top;color:#98a1b3;-webkit-transition:color .2s;transition:color .2s" :href="'https://termify.io/return-and-refund/'+website.returnandrefundid" target="_blank">{{propsdata[0]['translation']['websites-refund']}}</a>
                              </div>
                              </div>
                           <div class="col-12 col-md-6 align-items-center justify-content-md-end">
                             <p class="stretched-link"><i class="fas fa-code"></i><span class="h6 text-sm ml-2">{{propsdata[0]['translation']['websites-add-script']}}</span></p>
<textarea class="form-control" style="z-index: 1;position: inherit;height: 295px;resize: none;" onfocus="this.select()" readonly>&lt;script type="text/javascript"&gt;
window.onload = function(){
 (function(d, script) {
 script = d.createElement('script');
 script.type = 'text/javascript';
 script.async = true;
 script.src = 'https://termify.io/script/{{website.scriptid}}.js';
 d.getElementsByTagName('head')[0].appendChild(script);
}(document));
};
&lt;/script&gt;</textarea>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div v-else class="row justify-content-center mb-5 mb-lg-6">
               <div class="col-12 text-center">
                  <h2 class="h1 mb-3">{{propsdata[0]['translation']['websites-showcase']}}</h2>
                  <p class="lead px-5 px-lg-7">{{propsdata[0]['translation']['websites-can-help']}}</p>
                  <router-link to="/dashboard/add-website" class="sc-kkGfuU sc-dHIava sc-bSbAYC dqUEtJ" style="color: rgb(255, 255, 255); display: initial !important;"><svg width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-jhaWeW kclIni"><path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path></svg>{{propsdata[0]['translation']['websites-add']}}</router-link>
               </div>
            </div>
         </div>
      </section>
  </div>
</div>

</template>

<style>
@media (min-width:992px) {
  .btnaddweb{
    float: right;
    position: relative;
    bottom: 60px;
  }
}
</style>

  <script>
  export default {
    props:['propsdata'],
    data() {
      return {
        loading: true,
        websites: [],
        sure: false,
        numerosure: ''
      };
    },
    methods: {
      el_sure(num){
        if(this.sure){
          this.sure = false;
        }
        else{
          this.sure = true;
        }
        this.numerosure = num;
      },
      delete_draft(num){
        axios.post('/dashboard/delete-website.php', {
            id: this.websites[num].id
          })
          this.websites.splice(num, 1);
          this.sure = false;
          this.numerosure = '';
      }
    },
    mounted() {
      axios.post('/dashboard/cargar-websites.php', {
        })
        .then(response => {
          if(response.data == 'no pago'){
            window.location.replace("https://termify.io/choose-plan/"+this.propsdata[0].unique_id);
          }
          else{
            this.websites = response.data;
            this.loading = false;
          }
      })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  </script>



// WEBPACK FOOTER //
// src/websites.vue